import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Receipt from '../../../../../assets/images/module/general/ReceiptDummy.png';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import CustomModal from '.';
import { showNotification } from '@mantine/notifications';
import ColorButton from '../Buttons/ColorButton';
import CopyIcon from '../../../SVGs/copyIcon';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import RedCross from '../../../../../assets/images/module/general/RedCross.svg';
import { Checkbox, Group, Popover, Stack, TextInput } from '@mantine/core';
import EmptyStateContainer from '../EmptyStateContainer/EmptyStateContainer';
import TenantIconBlue from '../../../../../assets/images/module/general/TenantIconBlue.svg';
import { NumericFormat } from 'react-number-format';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import accounting from 'accounting';

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

export class ErrorLogsForMultiTenantUploadModal extends Component {
  state = {
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE,
    popoverOpened: false
  };
  
  constructor(props) {
    super(props);
  }

  renderTableHeader=()=>{
    return(
      <TableHead>
        <TableRow>
          <TableCell className='multi-tenant-upload-error-log-header'>Einheit</TableCell>
          <TableCell className='multi-tenant-upload-error-log-header'>Größe</TableCell>
          <TableCell className='multi-tenant-upload-error-log-header'>Mietertyp</TableCell>
          <TableCell className='multi-tenant-upload-error-log-header'>Mieter Name</TableCell>
          <TableCell className='multi-tenant-upload-error-log-header'>Telefonnummer (opt.)</TableCell>
          <TableCell className='multi-tenant-upload-error-log-header'>E-Mail Adresse (opt.)</TableCell>
          <TableCell className='multi-tenant-upload-error-log-header'>Einzugsdatum (TT.MM.JJJJ)</TableCell>
          <TableCell className='multi-tenant-upload-error-log-header'>Auszugsdatum (TT.MM.JJJJ) (opt.)</TableCell>
          <TableCell className='multi-tenant-upload-error-log-header'>Kaltmiete</TableCell>
          <TableCell className='multi-tenant-upload-error-log-header'>Vorauszahlungen</TableCell>
          <TableCell className='multi-tenant-upload-error-log-header'>Notizen (opt.)</TableCell>
        </TableRow>
      </TableHead>
    )
  }

  renderTableBody=(errorsFound=false)=>{
    const {tenants} = this.props;
    return(
      <TableBody>
        {tenants.filter((tenant)=> errorsFound ? this.isErrorsFound(tenant) : tenant)
        .sort((a,b)=> a.rentalUnitName.toLowerCase().localeCompare(b.rentalUnitName))
        .map((tenant, index)=>
        <TableRow 
        className="table-data" 
        style={{background: this.isErrorsFound(tenant) ? '#FFCBCB' : '#F7F7FA', height: '70px', cursor: 'pointer'}}
        onMouseEnter={() => this.setState({popoverOpened: `${index}_${3}`})} onMouseLeave={() => this.setState({popoverOpened: false})}>
          <TableCell className='multi-tenant-upload-error-log-body'>{this.isErrorsFound(tenant) ? this.showErrorPopover(tenant.rentalUnitName, tenant, index, 0) : tenant.rentalUnitName ? tenant.rentalUnitName : '-'}</TableCell>
          <TableCell className='multi-tenant-upload-error-log-body'>{this.isErrorsFound(tenant) ? this.showErrorPopover(accounting.formatMoney(tenant?.rentalUnitSpace, 'm²', 2, '.', ',', '%v %s'), tenant, index, 1) : accounting.formatMoney(tenant?.rentalUnitSpace, 'm²', 2, '.', ',', '%v %s')}</TableCell>
          <TableCell className='multi-tenant-upload-error-log-body'>{this.isErrorsFound(tenant) ? this.showErrorPopover(tenant.type, tenant, index, 2) : tenant.type ? tenant.type : '-'}</TableCell>
          <TableCell className='multi-tenant-upload-error-log-body'>{this.isErrorsFound(tenant) ? this.showErrorPopover(tenant.name, tenant, index, 3) : tenant.name ? tenant.name : '-'}</TableCell>
          <TableCell className='multi-tenant-upload-error-log-body'>{this.isErrorsFound(tenant) ? this.showErrorPopover(tenant.phone, tenant, index, 4) : tenant.phone ? tenant.phone : '-'}</TableCell>
          <TableCell className='multi-tenant-upload-error-log-body'>{this.isErrorsFound(tenant) ? this.showErrorPopover(tenant.email, tenant, index, 5) : tenant.email ? tenant.email : '-'}</TableCell>
          <TableCell className='multi-tenant-upload-error-log-body'>{this.isErrorsFound(tenant) ? this.showErrorPopover(tenant.in, tenant, index, 6) : tenant.in ? tenant.in : '-'}</TableCell>
          <TableCell className='multi-tenant-upload-error-log-body'>{this.isErrorsFound(tenant) ? this.showErrorPopover(tenant.out, tenant, index, 7) : tenant.out ? tenant.out : '-'}</TableCell>
          <TableCell className='multi-tenant-upload-error-log-body'>{this.isErrorsFound(tenant) ? this.showErrorPopover(accounting.formatMoney(tenant.netRent, '€', 2, '.', ',', '%v %s'), tenant, index, 8) : accounting.formatMoney(tenant.netRent, '€', 2, '.', ',', '%v %s')}</TableCell>
          <TableCell className='multi-tenant-upload-error-log-body'>{this.isErrorsFound(tenant) ? this.showErrorPopover(accounting.formatMoney(tenant.prePayments, '€', 2, '.', ',', '%v %s'), tenant, index, 9) : accounting.formatMoney(tenant.prePayments, '€', 2, '.', ',', '%v %s')}</TableCell>
          <TableCell className='multi-tenant-upload-error-log-body'>{this.isErrorsFound(tenant) ? this.showErrorPopover(tenant.notes, tenant, index, 10) : tenant.notes ? tenant.notes : '-'}</TableCell>
        </TableRow>)}
      </TableBody>
    )
  }

  showErrorPopover=(value, tenant, index, column)=> 
  <Popover
  // Behält die Logik für das kontrollierte Öffnen bei
  opened={this.state.popoverOpened === `${index}_${column}`}
  zIndex={999999}
  withArrow
  position="top"
  // placement="center" wurde entfernt, da v7 dies automatisch handhabt
>
  {/* 1. Der Target-Bereich für den Trigger */}
  <Popover.Target>
    <span>{value ? value : '-'}</span>
  </Popover.Target>

  {/* 2. Der Dropdown-Bereich für die Fehlermeldungen */}
  <Popover.Dropdown p="xs">
    <Stack>
      {tenant.alreadyInSystem && (
        <Group wrap="nowrap">
          <img src={RedCross} alt="Error" />
          <span className="multi-tenant-upload-error-log-body">
            Ein gleichartiger Mietereintrag befindet sich bereits im System.
          </span>
        </Group>
      )}
      
      {tenant.dateOverlap && (
        <Group wrap="nowrap">
          <img src={RedCross} alt="Error" />
          <span className="multi-tenant-upload-error-log-body">
            Für den Mietzeitraum wurde bereits ein Mieter angelegt. Mietzeiträume dürfen sich nicht überschneiden.
          </span>
        </Group>
      )}
      
      {tenant.rentalUnitError && (
        <Group wrap="nowrap">
          <img src={RedCross} alt="Error" />
          <span className="multi-tenant-upload-error-log-body">
            Die Angabe der Mieteinheit fehlt.
          </span>
        </Group>
      )}
      
      {tenant.nameError && (
        <Group wrap="nowrap">
          <img src={RedCross} alt="Error" />
          <span className="multi-tenant-upload-error-log-body">
            Die Angabe des Mieternamens fehlt.
          </span>
        </Group>
      )}
      
      {tenant.typeError && (
        <Group wrap="nowrap">
          <img src={RedCross} alt="Error" />
          <span className="multi-tenant-upload-error-log-body">
            Die Angabe der Art des Mietverhältnisses fehlt oder ist ungültig.
          </span>
        </Group>
      )}
      
      {tenant.moveInDateError && (
        <Group wrap="nowrap">
          <img src={RedCross} alt="Error" />
          <span className="multi-tenant-upload-error-log-body">
            Die Angabe des Einzugsdatums fehlt oder ist ungültig.
          </span>
        </Group>
      )}
    </Stack>
  </Popover.Dropdown>
</Popover>;

  //alreadyInSystem: false, nameError: false, rentalUnitError: false, typeError: false, moveInDateError: false, dateOverlap: false

  isErrorsFound=(tenant)=>{
    if(tenant.nameError || tenant.rentalUnitError || tenant.typeError || tenant.moveInDateError || tenant.alreadyInSystem || tenant.dateOverlap){
      return true;
    }else{
      return false;
    }
  }

  missingInformationErrorFound=(tenant)=>{
    if(tenant.nameError || tenant.rentalUnitError || tenant.typeError || tenant.moveInDateError){
      return true;
    }else{
      return false;
    }
  }

  generalErrorFound=(tenant)=>{
    if(tenant.alreadyInSystem || tenant.dateOverlap){
      return true;
    }else{
      return false;
    }
  }
  
  render() {
    const { open, toggle, className, next, tenants } = this.props;
    let errorsFound = tenants.find((tenant)=> this.isErrorsFound(tenant)) === undefined ? false : true;
    let generalError = tenants.find((tenant)=> this.generalErrorFound(tenant)) === undefined ? false : true;
    let missingInformationError = tenants.find((tenant)=> this.missingInformationErrorFound(tenant)) === undefined ? false : true;
    return (
      <CustomModal
        heading={'Importdaten überprüfen'}
        headingClassName={'import-multiple-tenant-data-modal-heading'}
        open={open}
        toggle={() => {
          toggle();
        }}
        className={`${className}`}
        style={{minWidth: '1200px'}}
      >
        <Stack>
            <Group>
              {errorsFound === false ? 
              <span style={{fontWeight: '400'}}>
                {tenants.length > 1 ?
                  <span>{tenants.length} Einträge wurden erfolgreich erkannt und können nun importiert werden. Klicken Sie auf <span style={{fontWeight: 'bold'}}>Fortfahren</span>, um den Import zu starten.</span>
                  :
                  <span>1 Eintrag wurde erfolgreich erkannt und kann nun importiert werden. Klicken Sie auf <span style={{fontWeight: 'bold'}}>Fortfahren</span>, um den Import zu starten.</span>
                }
              </span>
              :
              missingInformationError ?
              <span style={{fontWeight: '400'}}>Bei {tenants.filter((tenant)=> this.missingInformationErrorFound(tenant))?.length} Einträgen wurden Fehler gefunden. Bitte überprüfen Sie die Einträge in der Liste unten, korrigieren Sie die Import-Datei und laden Sie diese erneut hoch.</span>
              :
              generalError ?
              <span style={{fontWeight: '400'}}>Es ist ein Fehler aufgetreten. Bitte überprüfen Sie Import-Datei und probieren Sie diese erneut hochzuladen.</span>
              :
              ''}
            </Group>
            <Group>
              <TableContainer>
                <Table stickyHeader
                  className='fixed'
                  style={{
                    border: 'none',
                    borderCollapse: 'separate',
                    borderSpacing: '0px 8px',
                  }}>
                  {this.renderTableHeader()}
                  {this.renderTableBody(errorsFound)}
                </Table>
              </TableContainer>
            </Group>
            <Group justify="space-between">
                <div>
                    <ColorButton
                    text={'Schließen'}
                    className='gray-btn'
                    onClick={()=> toggle()}
                    />
                </div>
                <div>
                    <ColorButton
                    text={'Fortfahren'}
                    className='purple-btn'
                    onClick={()=> next()}
                    disabled={tenants.find((tenant)=> this.isErrorsFound(tenant)) !== undefined}
                    />
                </div>
            </Group>
        </Stack>
      </CustomModal>
    );
  }
}

export default ErrorLogsForMultiTenantUploadModal;
